/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 * Page Reports Constructor List component
 *
 * @author Evgeniy Naumov
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import type { FC } from 'react';

import { EConstructorItem } from '../constants';
import type { IConstructorReport, IConstructorTemplate } from '../types';
import { sliceItemsToRows } from '../utils/tableConstructorSchedule';
import { ConstructorItemsRow } from './ConstructorItemsRow';
import { ConstructorListStyled } from './styled/ConstructorStyled';

interface IProps {
    title: string;
    items: IConstructorReport[] | IConstructorTemplate[];
    rowType?: EConstructorItem;
}

export const ConstructorItemsList: FC<IProps> = ({ items, rowType, title }) => {
    if (!items.length) {
        return null;
    }

    const itemRows = sliceItemsToRows<IConstructorReport | IConstructorTemplate>(items, 3);

    return (
        <>
            <h3>{title}</h3>
            <ConstructorListStyled>
                {itemRows.map((item) => {
                    const { rowId, row } = item;
                    return <ConstructorItemsRow key={rowId} row={row} rowId={rowId} rowType={rowType} />;
                })}
            </ConstructorListStyled>
        </>
    );
};
